import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { ApiLink } from "../APILink/ApiLink";
import authHeader from "../Auth/authHeader";
import getRole from "../Auth/GetRole";
import getCompanyPack from "../Auth/GetCompanyPack";
import { menuItemss } from "../SidebarMenu/SideMenu";

let cachedIdentity = null;
let cachedContext = null;

function getAccessContext() {
  const headers = authHeader();
  const identity = headers.Authorization;
  if (!identity) return Promise.resolve(null);
  if (cachedIdentity === identity && cachedContext) return cachedContext;

  cachedIdentity = identity;
  cachedContext = Promise.all([getRole(headers), getCompanyPack(headers)])
    .then(([role, pack]) => {
      if (!role || !pack) {
        cachedContext = null;
        return null;
      }
      return { role, pack };
    })
    .catch(() => {
      cachedContext = null;
      return null;
    });
  return cachedContext;
}

export function isAllowedByLegacyMenu(menuPath, role, pack) {
  const paths = menuPath === "/notary/salesindetails"
    ? [menuPath, "/Sales/salesindetails"]
    : [menuPath];

  return menuItemss.some(parent => {
    if (!parent.role?.includes(role) || !parent.pack?.includes(pack)) return false;
    if (paths.some(path => parent.to?.toLowerCase() === path.toLowerCase())) return true;
    return parent.subMenus?.some(child =>
      paths.some(path => child.to?.toLowerCase() === path.toLowerCase()) &&
      child.pack?.includes(pack) &&
      (child.to !== "/admin/access-monitoring" || role === "acctree")
    ) || false;
  });
}

export default function LegacyMenuAccessGate({ menuPath, action = "view", children }) {
  const [result, setResult] = useState({ menuPath: null, status: "loading" });

  useEffect(() => {
    let active = true;
    setResult({ menuPath, status: "loading" });
    axios.get(`${ApiLink.API_URL}MenuAccess/check`, {
      headers: authHeader(),
      params: { path: menuPath, action },
      timeout: 15000,
    }).then(({ data }) => {
      if (active) setResult({ menuPath, status: data?.allowed === true ? "allowed" : "denied" });
    }).catch(async (error) => {
      if (!active) return;
      // Only a missing new endpoint may use the old menu rules as backup.
      if (error?.response?.status !== 404) {
        setResult({ menuPath, status: "denied" });
        return;
      }
      const context = await getAccessContext();
      if (active) setResult({
        menuPath,
        status: context && isAllowedByLegacyMenu(menuPath, context.role, context.pack)
          ? "allowed" : "denied",
      });
    });
    return () => { active = false; };
  }, [menuPath, action]);

  if (result.menuPath === menuPath && result.status === "allowed") return children;
  if (result.menuPath !== menuPath || result.status === "loading") {
    return <div role="status" style={{ padding: 32 }}>Duke kontrolluar qasjen…</div>;
  }
  return <div style={{ padding: 32 }}><h1>Qasja nuk lejohet</h1><Link to="/dashboard">Kthehu te paneli</Link></div>;
}
